import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getCollections, getProducts } from "@/lib/api";
import { useSEO, breadcrumbSchema } from "@/lib/seo";
import PageHeader from "@/components/PageHeader";
import CategoryCard from "@/components/shop/CategoryCard";
import { StaggerGroup, StaggerItem } from "@/components/motion/Reveal";

export default function CategoriesIndex() {
  const { data: collections = [] } = useQuery({ queryKey: ["collections"], queryFn: getCollections });
  const { data: productData } = useQuery({ queryKey: ["products"], queryFn: () => getProducts() });
  const products = productData?.products || [];
  const counts = products.reduce((acc, p) => ((acc[p.collection] = (acc[p.collection] || 0) + 1), acc), {});

  useSEO({
    title: "Product Categories | Renova Peptide Co.",
    description:
      "Explore Renova Peptide Co. research collections — organized groupings of laboratory research materials with clear documentation.",
    path: "/categories",
    jsonLd: breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Categories", path: "/categories" },
    ]),
  });

  return (
    <>
      <PageHeader
        overline="Browse"
        title="Product Categories"
        intro="Our research materials are organized into focused collections to make the catalogue easy to navigate."
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Categories", path: "/categories" }]}
      />
      <section className="container-rnv py-16 md:py-24">
        <StaggerGroup className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {collections.map((c) => (
            <StaggerItem key={c.slug}><CategoryCard collection={c} count={counts[c.slug]} /></StaggerItem>
          ))}
        </StaggerGroup>
      </section>
    </>
  );
}
